"use client";

import { useEffect, useId, useRef } from "react";
import "./layout-image-dialog.css";

export function LayoutImageDialog({
  src,
  title,
  returnFocus,
  onClose,
}: {
  src: string;
  title: string;
  returnFocus: HTMLButtonElement;
  onClose: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const close = useRef<HTMLButtonElement>(null);
  const headingId = useId();

  useEffect(() => {
    const element = dialog.current;
    const overflow = document.body.style.overflow;
    element?.showModal();
    document.body.style.overflow = "hidden";
    close.current?.focus();
    return () => {
      element?.close();
      document.body.style.overflow = overflow;
      returnFocus.focus({ preventScroll: true });
    };
  }, [returnFocus]);

  return (
    <dialog
      ref={dialog}
      className="layout-image-dialog"
      aria-labelledby={headingId}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <div className="layout-image-dialog-heading">
        <h2 id={headingId}>{title}</h2>
        <button
          ref={close}
          type="button"
          className="secondary-button"
          aria-label="配置図の拡大表示を閉じる"
          onClick={onClose}
        >
          閉じる
        </button>
      </div>
      <div className="layout-image-dialog-stage">
        {/* biome-ignore lint/performance/noImgElement: Reuse the authenticated original SVG Blob at full resolution. */}
        <img src={src} alt={`${title}のテーブル配置図（拡大表示）`} />
      </div>
    </dialog>
  );
}
